
import TraineeAccomplishments from "@/components/TraineeAccomplishments";
import GlobalDiversityInclusion from "@/components/GlobalDiversityInclusion";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import BackToTop from "@/components/BackToTop";

const Accomplishments = () => {
  return (
    <div className="min-h-screen bg-white overflow-x-hidden">
      <Header />
      <div className="pt-8">
        <GlobalDiversityInclusion />
        <TraineeAccomplishments />
      </div>
      <Footer />
      <BackToTop />
    </div>
  );
};

export default Accomplishments;
